const ScheduleTypes = [
  { text: 'Calendar', value: 'calendar', typeId: 1 },
  { text: 'Visit', value: 'visit', typeId: 2 }
]

export default ScheduleTypes
